import { render } from "./RequestNewUserModal.vue?vue&type=template&id=ca7a7634&scoped=true"
import script from "./RequestNewUserModal.vue?vue&type=script&lang=js"
export * from "./RequestNewUserModal.vue?vue&type=script&lang=js"

import "./RequestNewUserModal.vue?vue&type=style&index=0&id=ca7a7634&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7a7634"]])

export default __exports__